
export default function ServicesHero() {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Our Marketing Services
        </h1>
        <p className="text-xl text-blue-100 max-w-3xl mx-auto">
          Comprehensive digital marketing solutions designed to accelerate your business growth and maximize your online presence across all channels.
        </p>
      </div>
    </section>
  );
}
